import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-call-icon',
  templateUrl: './communication-call.component.html'
})
export class CommunicationCallComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
